import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "users?user_role=admin_enterprise",
    object: "user",
    header: [
      { text: "ID", value: "id" },
      { text: "Email", value: "email" },
      { text: "Company", value: "company_id" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    roles: [],
    options: {
      sortBy: ["id"],
      sortDesc: [true]
    }
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions,
    getRoles({ commit }) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "roles")
          .then(response => {
            commit("success", { roles: response.data });
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    },
    delete({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .delete(config.api_url + "users" + "/" + data.id)
          .then(() => {
            commit("success");
            resolve();
          })
          .catch(error => {
            console.log(error);
            commit("error");
            reject(error.response.data);
          });
      });
    },
    show({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "users" + "/" + id)
          .then(response => {
            commit("success");
            resolve(response.data[state.object]);
          })
          .catch(err => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
    update({ commit, state }, data) {
      let saveData = {};
      saveData[state.object] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        const formData = jsonToFormData(saveData, {
          arrayIndexes: true,
          excludeNull: true
        });
        axios
          .put(config.api_url + "users" + "/" + data.id, formData)
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            commit("error");
            reject(error.response.data);
          });
      });
    }
  },
  getters: {
    ...genericStore.getters
  }
};
